import api from '../api';

class GroupsApiService {
  /**
   * Get all groups
   */
  async getAllGroups() {
    try {
      const response = await api.get('/groups/');
      return response.data;
    } catch (error) {
      console.error('Error fetching groups:', error);
      throw error;
    }
  }

  /**
   * Get specific group by ID
   */
  async getGroupById(groupId) {
    try {
      const response = await api.get(`/groups/${groupId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching group ${groupId}:`, error);
      throw error;
    }
  }

  /**
   * Create a new group
   */
  async createGroup(groupId) {
    try {
      const response = await api.post('/groups/', {
        group_id: groupId
      });
      return response.data;
    } catch (error) {
      console.error('Error creating group:', error);
      throw error;
    }
  }

  /**
   * Assign agent to a group
   */
  async assignAgentToGroup(agentId, groupId, force = false) {
    try {
      const response = await api.put(`/groups/${groupId}/agents`, {
        agent_id: agentId,
        group_id: groupId,
        force: force
      });
      return response.data;
    } catch (error) {
      console.error('Error assigning agent to group:', error);
      throw error;
    }
  }

  /**
   * Get all agents in a group
   */
  async getGroupAgents(groupId) {
    try {
      const response = await api.get(`/groups/${groupId}/agents`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching agents for group ${groupId}:`, error);
      throw error;
    }
  }

  /**
   * Delete a group
   */
  async deleteGroup(groupId) {
    try {
      const response = await api.delete(`/groups/${groupId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting group:', error);
      throw error;
    }
  }

  /**
   * Remove agent from a group
   */
  async removeAgentFromGroup(groupId, agentId) {
    try {
      const response = await api.delete(`/groups/${groupId}/agents/${agentId}`);
      return response.data;
    } catch (error) {
      console.error('Error removing agent from group:', error);
      throw error;
    }
  }
}

export default new GroupsApiService();
